import "@code-hike/mdx/dist/index.css";
import React from "react";

export const wrapPageElement = ({ element, props }) => {
  const Layout = element.type.Layout ?? React.Fragment

  return <Layout {...props}>{element}</Layout>
};
